import { Component, OnInit, Input } from '@angular/core';
import { OPTIONS_MENU } from '@app/enums/flows.enum';
import { BoardinPass } from '@app/models/micro/boardin-pass.model';
import { Reservation } from '@app/models/micro/reservation.model';


@Component({
    selector: 'am-actions-menu',
    templateUrl: './am-actions-menu.component.html',
    styleUrls: ['./am-actions-menu.component.scss'],
    standalone: false
})
export class AmActionsMenuComponent implements OnInit {
  
  @Input() action: any;
  language: string = "";
  reservation: Reservation;
  boardinPass: BoardinPass;
  optionSelected: OPTIONS_MENU;

  constructor() { }

  ngOnInit(): void {
   
  }
}
